import { render, staticRenderFns } from "./SlsD_Items.vue?vue&type=template&id=9a6f5818"
import script from "./SlsD_Items.vue?vue&type=script&lang=js"
export * from "./SlsD_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports